/**
 * @generated SignedSource<<e4e8cecb078ecc9028137dc95e0de3c3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RouteConfig_ProjectScreenerPage_Query$variables = {
  studyId: string;
};
export type RouteConfig_ProjectScreenerPage_Query$data = {
  readonly viewer: {
    readonly study: {
      readonly screener: {
        readonly " $fragmentSpreads": FragmentRefs<"ProjectScreenerPage_screener">;
      } | null;
    } | null;
  };
};
export type RouteConfig_ProjectScreenerPage_Query = {
  response: RouteConfig_ProjectScreenerPage_Query$data;
  variables: RouteConfig_ProjectScreenerPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "studyId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "studyId",
    "variableName": "studyId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "importKey",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortName",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CharacteristicNode",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/)
    ],
    "storageKey": null
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dbId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "position",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "randomize",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "responseValidation",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "target",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "target2",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "targetTypes",
  "storageKey": null
},
v15 = [
  (v2/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "terminate",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RouteConfig_ProjectScreenerPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "StudyNode",
            "kind": "LinkedField",
            "name": "study",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ScreenerNode",
                "kind": "LinkedField",
                "name": "screener",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ProjectScreenerPage_screener"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RouteConfig_ProjectScreenerPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "StudyNode",
            "kind": "LinkedField",
            "name": "study",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ScreenerNode",
                "kind": "LinkedField",
                "name": "screener",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StudyNode",
                    "kind": "LinkedField",
                    "name": "study",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "namePublic",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TenantNode",
                        "kind": "LinkedField",
                        "name": "tenant",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "enableThreatDetection",
                            "storageKey": null
                          },
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CharacteristicNodeConnection",
                            "kind": "LinkedField",
                            "name": "characteristics",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CharacteristicNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": (v7/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TenantGlobalCharacteristicsConnection",
                            "kind": "LinkedField",
                            "name": "globalCharacteristics",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TenantGlobalCharacteristicsEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": (v7/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RecruitNode",
                        "kind": "LinkedField",
                        "name": "testRecruit",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "screenerLink",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ElementNodeConnection",
                    "kind": "LinkedField",
                    "name": "elements",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ElementNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ElementNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v8/*: any*/),
                              (v9/*: any*/),
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "label",
                                "storageKey": null
                              },
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CharacteristicNode",
                                "kind": "LinkedField",
                                "name": "characteristic",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CharacteristicAnswerNode",
                                    "kind": "LinkedField",
                                    "name": "answers",
                                    "plural": true,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v9/*: any*/),
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CharacteristicElementMetaNode",
                                    "kind": "LinkedField",
                                    "name": "elementMeta",
                                    "plural": false,
                                    "selections": [
                                      (v10/*: any*/),
                                      (v11/*: any*/),
                                      (v12/*: any*/),
                                      (v13/*: any*/),
                                      (v14/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v5/*: any*/),
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TenantNode",
                                    "kind": "LinkedField",
                                    "name": "tenant",
                                    "plural": false,
                                    "selections": (v15/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ScreenerNode",
                                "kind": "LinkedField",
                                "name": "screener",
                                "plural": false,
                                "selections": (v15/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AssetNode",
                                "kind": "LinkedField",
                                "name": "asset",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "url",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v11/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "usePreviousAnswers",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AnswerNodeConnection",
                                "kind": "LinkedField",
                                "name": "answers",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AnswerNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "AnswerNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v2/*: any*/),
                                          (v8/*: any*/),
                                          (v9/*: any*/),
                                          (v3/*: any*/),
                                          (v16/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "quota",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "other",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "rating",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "exclusive",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "userSpecified",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "terminateCondition",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RowNodeConnection",
                                "kind": "LinkedField",
                                "name": "rows",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RowNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RowNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v2/*: any*/),
                                          (v9/*: any*/),
                                          (v3/*: any*/),
                                          (v8/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "showIfCondition",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "GridAnswerNode",
                                "kind": "LinkedField",
                                "name": "gridAnswers",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RowNode",
                                    "kind": "LinkedField",
                                    "name": "row",
                                    "plural": false,
                                    "selections": (v15/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AnswerNode",
                                    "kind": "LinkedField",
                                    "name": "answer",
                                    "plural": false,
                                    "selections": (v15/*: any*/),
                                    "storageKey": null
                                  },
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "goal",
                                    "storageKey": null
                                  },
                                  (v16/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SegmentNodeConnection",
                    "kind": "LinkedField",
                    "name": "segments",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SegmentNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SegmentNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v8/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "eeb4cde28397d150486b287fe6009ceb",
    "id": null,
    "metadata": {},
    "name": "RouteConfig_ProjectScreenerPage_Query",
    "operationKind": "query",
    "text": "query RouteConfig_ProjectScreenerPage_Query(\n  $studyId: String!\n) {\n  viewer {\n    study(studyId: $studyId) {\n      screener {\n        ...ProjectScreenerPage_screener\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment ActiveElementContent_element on ElementNode {\n  id\n  text\n  asset {\n    id\n    url\n  }\n  type\n  label\n  target\n  target2\n  targetTypes\n  responseValidation\n  usePreviousAnswers\n  screener {\n    id\n  }\n  position\n  characteristic {\n    answers {\n      id\n      position\n      text\n    }\n    elementMeta {\n      randomize\n      responseValidation\n      target\n      target2\n      targetTypes\n    }\n    importKey\n    shortName\n    tenant {\n      id\n    }\n    id\n  }\n  answers {\n    edges {\n      node {\n        id\n        dbId\n        position\n        text\n        ...Option_answer\n      }\n    }\n  }\n  rows {\n    edges {\n      node {\n        id\n        position\n        text\n        ...Row_row\n      }\n    }\n  }\n  randomize\n  showIfCondition\n  ...AddOption_element\n  ...GridQuestionEditor_element\n  ...InputFilterGroupGroup_element\n  ...Option_element\n  ...Row_element\n  ...UsePreviousAnswers_element\n}\n\nfragment ActiveElementContent_screener on ScreenerNode {\n  id\n  elements {\n    edges {\n      node {\n        id\n        characteristic {\n          importKey\n          id\n        }\n      }\n    }\n  }\n  study {\n    status\n    tenant {\n      characteristics {\n        edges {\n          node {\n            text\n            type\n            importKey\n            shortName\n            id\n          }\n        }\n      }\n      globalCharacteristics {\n        edges {\n          node {\n            text\n            type\n            importKey\n            shortName\n            id\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n  ...InputFilterGroupGroup_screener\n  ...UsePreviousAnswers_screener\n}\n\nfragment AddOption_element on ElementNode {\n  id\n  type\n  answers {\n    edges {\n      node {\n        id\n        text\n        terminate\n        quota\n        other\n        position\n      }\n    }\n  }\n}\n\nfragment AuditionTextElement_element on ElementNode {\n  ...ElementBase_element\n}\n\nfragment AuditionTextElement_screener on ScreenerNode {\n  ...ElementBase_screener\n}\n\nfragment AuditionVideoElement_element on ElementNode {\n  ...ElementBase_element\n}\n\nfragment AuditionVideoElement_screener on ScreenerNode {\n  ...ElementBase_screener\n}\n\nfragment CommentElement_element on ElementNode {\n  ...ElementBase_element\n}\n\nfragment CommentElement_screener on ScreenerNode {\n  ...ElementBase_screener\n}\n\nfragment DateElement_element on ElementNode {\n  ...ElementBase_element\n}\n\nfragment DateElement_screener on ScreenerNode {\n  ...ElementBase_screener\n}\n\nfragment DropdownElement_element on ElementNode {\n  ...ElementBase_element\n}\n\nfragment DropdownElement_screener on ScreenerNode {\n  ...ElementBase_screener\n}\n\nfragment ElementBase_element on ElementNode {\n  id\n  characteristic {\n    id\n  }\n  screener {\n    id\n  }\n  position\n  ...ActiveElementContent_element\n  ...InactiveElementContent_element\n}\n\nfragment ElementBase_screener on ScreenerNode {\n  study {\n    status\n    id\n  }\n  ...ActiveElementContent_screener\n  ...InactiveElementContent_screener\n}\n\nfragment Element_element on ElementNode {\n  type\n  ...ElementBase_element\n  ...SingleChoiceElement_element\n  ...MultiChoiceElement_element\n  ...RankElement_element\n  ...GridSingleSelectElement_element\n  ...DropdownElement_element\n  ...OpenEndElement_element\n  ...AuditionTextElement_element\n  ...AuditionVideoElement_element\n  ...CommentElement_element\n  ...NumberElement_element\n  ...VideoElement_element\n  ...DateElement_element\n  ...FilesElement_element\n}\n\nfragment Element_screener on ScreenerNode {\n  ...ElementBase_screener\n  ...SingleChoiceElement_screener\n  ...MultiChoiceElement_screener\n  ...RankElement_screener\n  ...GridSingleSelectElement_screener\n  ...DropdownElement_screener\n  ...OpenEndElement_screener\n  ...AuditionTextElement_screener\n  ...AuditionVideoElement_screener\n  ...CommentElement_screener\n  ...NumberElement_screener\n  ...VideoElement_screener\n  ...DateElement_screener\n  ...FilesElement_screener\n}\n\nfragment FilesElement_element on ElementNode {\n  ...ElementBase_element\n}\n\nfragment FilesElement_screener on ScreenerNode {\n  ...ElementBase_screener\n}\n\nfragment GridQuestionEditor_element on ElementNode {\n  id\n  usePreviousAnswers\n  characteristic {\n    importKey\n    id\n  }\n  answers {\n    edges {\n      node {\n        id\n        position\n        terminate\n        text\n      }\n    }\n  }\n  rows {\n    edges {\n      node {\n        id\n        text\n        position\n      }\n    }\n  }\n  gridAnswers {\n    row {\n      id\n    }\n    answer {\n      id\n    }\n    id\n    goal\n    terminate\n  }\n}\n\nfragment GridSingleSelectElement_element on ElementNode {\n  ...ElementBase_element\n}\n\nfragment GridSingleSelectElement_screener on ScreenerNode {\n  ...ElementBase_screener\n}\n\nfragment InactiveElementContent_element on ElementNode {\n  type\n  text\n  label\n  position\n  usePreviousAnswers\n  answers {\n    edges {\n      node {\n        text\n        id\n      }\n    }\n  }\n  rows {\n    edges {\n      node {\n        text\n        id\n      }\n    }\n  }\n  showIfCondition\n}\n\nfragment InactiveElementContent_screener on ScreenerNode {\n  elements {\n    edges {\n      node {\n        id\n        label\n        text\n        type\n        rows {\n          edges {\n            node {\n              id\n              text\n            }\n          }\n        }\n        answers {\n          edges {\n            node {\n              id\n              text\n            }\n          }\n        }\n      }\n    }\n  }\n  segments {\n    edges {\n      node {\n        id\n        text\n      }\n    }\n  }\n}\n\nfragment InputFilterGroupGroup_element on ElementNode {\n  id\n  ...InputFilterGroup_element\n}\n\nfragment InputFilterGroupGroup_screener on ScreenerNode {\n  id\n  ...InputFilterGroup_screener\n}\n\nfragment InputFilterGroup_element on ElementNode {\n  id\n  ...InputFilter_element\n}\n\nfragment InputFilterGroup_screener on ScreenerNode {\n  id\n  ...InputFilter_screener\n}\n\nfragment InputFilter_element on ElementNode {\n  position\n}\n\nfragment InputFilter_screener on ScreenerNode {\n  id\n  elements {\n    edges {\n      node {\n        id\n        dbId\n        position\n        type\n        text\n        label\n        answers {\n          edges {\n            node {\n              id\n              position\n              text\n              dbId\n            }\n          }\n        }\n        rows {\n          edges {\n            node {\n              id\n              dbId\n              text\n              position\n            }\n          }\n        }\n      }\n    }\n  }\n  segments {\n    edges {\n      node {\n        id\n        dbId\n        text\n      }\n    }\n  }\n}\n\nfragment MultiChoiceElement_element on ElementNode {\n  ...ElementBase_element\n}\n\nfragment MultiChoiceElement_screener on ScreenerNode {\n  ...ElementBase_screener\n}\n\nfragment NumberElement_element on ElementNode {\n  ...ElementBase_element\n}\n\nfragment NumberElement_screener on ScreenerNode {\n  ...ElementBase_screener\n}\n\nfragment OpenEndElement_element on ElementNode {\n  ...ElementBase_element\n}\n\nfragment OpenEndElement_screener on ScreenerNode {\n  ...ElementBase_screener\n}\n\nfragment OptionTerminate_answer on AnswerNode {\n  terminate\n  terminateCondition\n}\n\nfragment OptionTerminate_element on ElementNode {\n  type\n  answers {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n\nfragment Option_answer on AnswerNode {\n  id\n  text\n  terminate\n  quota\n  other\n  rating\n  exclusive\n  userSpecified\n  position\n  ...OptionTerminate_answer\n}\n\nfragment Option_element on ElementNode {\n  id\n  type\n  usePreviousAnswers\n  characteristic {\n    importKey\n    tenant {\n      id\n    }\n    id\n  }\n  ...OptionTerminate_element\n}\n\nfragment ProjectScreenerPage_screener on ScreenerNode {\n  id\n  title\n  description\n  study {\n    id\n    namePublic\n    status\n    tenant {\n      enableThreatDetection\n      id\n    }\n    testRecruit {\n      id\n      screenerLink\n    }\n  }\n  elements {\n    edges {\n      node {\n        id\n        dbId\n        position\n        text\n        label\n        ...Element_element\n      }\n    }\n  }\n  ...Element_screener\n}\n\nfragment RankElement_element on ElementNode {\n  ...ElementBase_element\n}\n\nfragment RankElement_screener on ScreenerNode {\n  ...ElementBase_screener\n}\n\nfragment Row_element on ElementNode {\n  type\n  characteristic {\n    id\n  }\n}\n\nfragment Row_row on RowNode {\n  id\n  text\n}\n\nfragment SingleChoiceElement_element on ElementNode {\n  ...ElementBase_element\n}\n\nfragment SingleChoiceElement_screener on ScreenerNode {\n  ...ElementBase_screener\n}\n\nfragment UsePreviousAnswers_element on ElementNode {\n  id\n  usePreviousAnswers\n}\n\nfragment UsePreviousAnswers_screener on ScreenerNode {\n  elements {\n    edges {\n      node {\n        id\n        text\n        type\n        characteristic {\n          importKey\n          id\n        }\n        answers {\n          edges {\n            node {\n              id\n              position\n              text\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment VideoElement_element on ElementNode {\n  ...ElementBase_element\n}\n\nfragment VideoElement_screener on ScreenerNode {\n  ...ElementBase_screener\n}\n"
  }
};
})();

(node as any).hash = "d63fe9f1baba1a701be5ce3d67297c81";

export default node;
